import React from 'react';

const formatDate = (value) => {
    if (!value) {
        return '';
    }
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }
    return parsedDate.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
};

const RecentArticles = ({ articles = [] }) => {
    const fallbackImage = 'assets/images/blog/img.png';

    return (
        <div className="recent-articles mb-4">
            <h5 className="mb-3">ARTICLES RÉCENTS</h5>
            {articles.length > 0 ? (
                <ul className="list-unstyled">
                    {articles.map((article) => (
                        <li key={article.id} className="d-flex align-items-center mb-3">
                            <img
                                src={article.image_url || article.image || fallbackImage}
                                alt={article.titre || article.title || 'Article récent'}
                                className="article-image me-3 mb-3"
                            />
                            <div>
                                <p className="mb-1 text-truncate" style={{ maxWidth: 200 }}>
                                    {article.titre || article.title || 'Sans titre'}
                                </p>
                                <span className="text-muted">{formatDate(article.created_at || article.date)}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="text-muted mb-0">Aucun article récent disponible pour le moment.</p>
            )}
        </div>
    );
};

export default RecentArticles;
